module.exports = __webpack_public_path__ + "static/media/inclusion.6bc5dcaf.jpg";